export default "__VITE_ASSET__0287c338__"